import PersonIcon from "@mui/icons-material/Person";
// import { Box, Button, Typography, Modal, Grid } from "@mui/material";

import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Typography,
  IconButton,
  Grid,
  Box,
  Modal,
  DialogTitle,
  Tabs,
  Tab,
  Switch,
  FormGroup,
} from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ShareIcon from '@mui/icons-material/Share';
// import "./test.css";

import dayjs from "dayjs";

// import { bookApoinment } from "./asppoinmentApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { routePath } from "../../constants/routePath";
import { setSession } from "../../utils/commonUtils";
import { setCustomerAppointmentId } from "../../app/store/reducer";
// import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { validationPersonalInfo } from "../payment/validation";
import Swal from "sweetalert2";
import ImageUploader from "../../common/imageUpload";
import { TextFieldSearch } from "../../common/fieldText";
import PoprchModal from "../payment/popSearch";
import { UpdateProfile, addProfile, getGusinessProfile } from "./busnessProfileModalapi";
import { ModalHeader } from "../../common/modalHeader";
import MediaCardInput from "../../common/mediaCardInput";
// import { getAlldetailSerice } from "../services/servicesListApi";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function


  ElegentProfileModal({
    open,
    setOpen,
    modalData,
    getAll,
  }) {
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const onCloseFn = () => {
    setOpen(false)
  }
  return (
    <Modal
      open={open}
      onClose={onCloseFn}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: {sm:"20%", xs:"25%"},

          left: { xs: "2%", sm: "25%", md: "25%", lg: "30%", xl: "35%" },

          // transform: "translate(-50%, -50%)",
          width: { xs: "95%", sm: "60%", md: "50%", lg: "40%", xl: "30%" },

          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          overflowY: "auto",
        }}
      >
        <ModalHeader
          title="Share Elegent Prime Profile"
          onClose={(data) => {
            setOpen(data);
          }}
        />

        <Box>
          <Grid container sx={{ padding: {sm:"20px", xs:"8px"} }}>
            {/* <MediaCardInput
            title={"Profile Id"}
            url={userDetail?.profileId} iIcon={<PersonIcon />} value={userDetail?.profileId} setValue={() => { }} /> */}
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  padding: "10px",
                  backgroundColor: "#EEEEFF",
                  boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.25)",
                  borderRadius: "5px",
                  width: "500px",
                  margin: "10px 0",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  color="grey"
                  sx={{
                    margin: "0px !important",
                    padding: "0px !important",
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    justifyContent: "space-between",
                    color: "#4E4E4E",
                    // fontSize: "16px",
                  }}
                >
                  <Typography
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      fontWeight: 600,
                    }}
                  >
                    <PersonIcon
                      sx={{
                        color: "#01008B",
                        cursor: "pointer",
                        marginRight: "10px",
                      }}
                    />
                    Profile ID
                  </Typography>
                  <Typography>
                    <IconButton
                      sx={{ marginRight: "10px" }}
                      onClick={() => {
                        navigator.clipboard.writeText(
                          userDetail?.profileId || ""
                        );
                        alert("Link copied to clipboard!");
                      }}
                      aria-label="copy link"
                    >
                      <ContentCopyIcon sx={{ color: "#01008B" }} />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        if (navigator.share) {
                          navigator
                            .share({
                              title: "Share Link",
                              url: userDetail?.profileId,
                            })
                            .catch((error) =>
                              console.error("Error sharing:", error)
                            );
                        } else {
                          alert(
                            "Share not supported on this browser. Link copied instead."
                          );
                          navigator.clipboard.writeText(
                            userDetail?.profileId || ""
                          );
                        }
                      }}
                      aria-label="share link"
                    >
                      <ShareIcon sx={{ color: "#01008B" }} />
                    </IconButton>
                  </Typography>
                </Box>
                <TextField
                  fullWidth
                  id="profileId"
                  label=""
                  variant="standard"
                  sx={{
                    margin: "0px !important",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    padding: "15px 0 !important",
                  }}
                  InputProps={{
                    sx: {
                      fontSize: { xs: "10px", sm: "13px", md: "15px" },
                      // padding: "15px 0",
                    },
                  }}
                  value={userDetail?.profileId}
                  onChange={(e) => {}}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
}
